<script setup>
  const show = ref(true);
  const flash = computed(() => usePage().props?.flash || '');
  const errors = computed(() => usePage().props?.errors);

  watch(
    () => flash,
    async () => {
      show.value = true;

      setTimeout(() => {
        show.value = false;
        // flash.value = _.mapValues(flash.value, () => null);
      }, 3000);
    },
    { deep: true },
  );
</script>

<template>
  <div class="flash">
    <Transition name="slide-fade">
      <Alert
        :title="$t(flash.success)"
        intent="success"
        v-if="flash.success && show"
        :on-dismiss="() => (show = false)"
      >
        <slot></slot>
      </Alert>

      <Alert
        :title="$t(flash.error ?? 'there_are_some_form_errors')"
        intent="danger"
        v-else-if="
          (flash.error || (errors && Object.keys(errors).length > 0)) && show
        "
        :on-dismiss="() => (show = false)"
      >
        <!-- <div class="py-4 text-sm font-medium">{{ flash?.success }}</div> -->
        <slot></slot>
      </Alert>

      <Alert
        :title="$t(flash.info)"
        intent="info"
        v-else-if="flash.info && show"
        :on-dismiss="() => (show = false)"
      >
        <slot></slot>
      </Alert>

      <Alert
        :title="$t(flash.warning)"
        intent="warning"
        v-else-if="flash.warning && show"
        :on-dismiss="() => (show = false)"
      >
        <slot></slot>
      </Alert>

      <Alert
        :title="$t(flash.message)"
        intent="default"
        v-else-if="flash.message && show"
        :on-dismiss="() => (show = false)"
      >
        <slot></slot>
      </Alert>
    </Transition>

    <!-- <div v-if="flash?.success && show" class="mb-8 flex items-center justify-between bg-lime-500 rounded">
			<div class="flex items-center">
				<svg class="ml-4 mr-2 flex-shrink-0 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
					<polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
				</svg>
				<div class="py-4 text-white text-sm font-medium">{{ flash?.success }}</div>
			</div>
			<button type="button" class="group mr-2 p-2" @click="show = false">
				<svg
					class="block w-3 h-3 fill-white"
					xmlns="http://www.w3.org/2000/svg"
					width="235.908"
					height="235.908"
					viewBox="278.046 126.846 235.908 235.908">
					<path
						d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" />
				</svg>
			</button>
		</div> -->

    <!-- <div
			v-if="(flash?.error || (errors && Object.keys(errors).length > 0)) && show"
			class="mb-8 flex items-center justify-between bg-rose-400 rounded">
			<div class="flex items-center">
				<svg class="ml-4 mr-2 flex-shrink-0 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
					<path
						d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" />
				</svg>
				<div v-if="flash?.error" class="py-4 text-white text-sm font-medium">{{ flash?.error }}</div>
				<div v-else class="py-4 text-white text-sm font-medium">
					<span v-if="errors && Object.keys(errors).length === 1">There is one form error.</span>
					<span v-else>There are {{ Object.keys(errors).length }} form errors.</span>
				</div>
			</div>
			<button type="button" class="group mr-2 p-2" @click="show = false">
				<svg
					class="block w-2 h-2 fill-white"
					xmlns="http://www.w3.org/2000/svg"
					width="235.908"
					height="235.908"
					viewBox="278.046 126.846 235.908 235.908">
					<path
						d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" />
				</svg>
			</button>
		</div> -->
  </div>
</template>

<style scoped>
  .flash {
    position: fixed;
    top: 2rem;
    right: 2rem;
    z-index: 1000;
    width: 20rem;
  }

  /*
  Enter and leave animations can use different
  durations and timing functions.
*/
  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(100px);
    opacity: 0;
  }
</style>
